export default class MapSpec {
    constructor() {
        this.minZoom = 0;
        this.maxZoom = 22;

        this.initialCenterLocation = null;
        this.initialOSMZoom = 0;
        this.initialCenterLocation = null;

        this.dataStreams = [];
        this.layers = [];
        this.searchableObjects = [];

        this.topLeftCorner = null;
        this.bottomRightCorner = null;

        this.attributionsHTMLUrl = "";
        this.name = "";

        this.languageAvailability = {
            english: true,
            french: true
        }
    }

    load() {
        // Must be overriden
        return Promise.resolve();
    }

    getMapObjectStructure() {
        throw ("must be overriden by subclasses");
    }

    getSearchPanelStructure() {
        return null;
    }
}